




















// @ts-ignore
import ResponsePopup from "./response-popup.ts";
export default ResponsePopup;
